import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 10, viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.02344 4.99989L5.55927 8.53572C5.88466 8.86111 5.88466 9.38867 5.55927 9.71406C5.23388 10.0394 4.70633 10.0394 4.38094 9.71406L0.373877 5.707C-0.0166469 5.31647 -0.0166464 4.68331 0.373878 4.29278L4.38094 0.285723C4.70633 -0.0396653 5.23388 -0.0396653 5.55927 0.285723C5.88466 0.611111 5.88466 1.13867 5.55927 1.46406L2.02344 4.99989Z", fill: "#3D84F6" }));
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
